import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Card,
  Col,
  Modal,
  Form,
  Button,
  Offcanvas,
} from "react-bootstrap";
import DataTable from "react-data-table-component";
import Breadcrumb from "Common/BreadCrumb";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Flatpickr from "react-flatpickr";
import { useFetchClassesQuery } from "features/classes/classeSlice";
import { useFetchMatieresByClasseIdQuery } from "features/matieres/matiereSlice";
import UpdateCalendrier from "./UpdateCalendrier";
import {
  useAddCalendrierMutation,
  useDeleteCalendrierMutation,
  useFetchCalendrierQuery,
} from "features/calendriers/calendrierSlice";
import { useFetchSallesQuery } from "features/salles/salleSlice";
import { French } from "flatpickr/dist/l10n/fr";
import { formatDate, formatTime } from "helpers/data_time_format";
import {
  useFetchSmsSettingsQuery,
  useUpdateSmsSettingByIdMutation,
} from "features/smsSettings/smsSettings";
import Select from "react-select";

const DevoirSynthese = () => {
  const { data = [] } = useFetchCalendrierQuery();

  const syntheseData = data.filter(
    (calendrier) => calendrier.type === "Synthèse"
  );

  const { data: AllSalles = [] } = useFetchSallesQuery();

  const { data: AllSmsSettings, isLoading = [] } = useFetchSmsSettingsQuery();

  const { data: AllClasses = [] } = useFetchClassesQuery();

  const [deleteCalendrier] = useDeleteCalendrierMutation();

  const [showCalendrier, setShowCalendrier] = useState<boolean>(false);

  const navigate = useNavigate();

  const notifySuccess = (msg: string) => {
    Swal.fire({
      position: "center",
      icon: "success",
      title: msg,
      showConfirmButton: false,
      timer: 2500,
    });
  };

  const notifyError = (err: any) => {
    Swal.fire({
      position: "center",
      icon: "error",
      title: `Sothing Wrong, ${err}`,
      showConfirmButton: false,
      timer: 2500,
    });
  };

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
  });

  const AlertDelete = async (_id: any) => {
    swalWithBootstrapButtons
      .fire({
        title: "Etes-vous sûr?",
        text: "Vous ne pouvez pas revenir en arrière?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui, supprime-le !",
        cancelButtonText: "Non, annuler !",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteCalendrier(_id);
          swalWithBootstrapButtons.fire(
            "Supprimé !",
            "Le calendrier est supprimé.",
            "success"
          );
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          swalWithBootstrapButtons.fire(
            "Annulé",
            "Le calendrier est en sécurité :)",
            "info"
          );
        }
      });
  };

  const [modal_AddCalendrier, setmodal_AddCalendrier] =
    useState<boolean>(false);
  function tog_AddCalendrier() {
    setmodal_AddCalendrier(!modal_AddCalendrier);
  }

  const [modal_UpdateCalendrier, setmodal_UpdateCalendrier] =
    useState<boolean>(false);
  function tog_UpdateCalendrier() {
    setmodal_UpdateCalendrier(!modal_UpdateCalendrier);
  }

  const [updateAvisSmsSetting] = useUpdateSmsSettingByIdMutation();
  const [formData, setFormData] = useState({
    id: "",
    status: "",
  });

  useEffect(() => {
    if (AllSmsSettings !== undefined && isLoading === false) {
      const devoir_sms_setting = AllSmsSettings?.filter(
        (parametre) => parametre.service_name === "Devoirs"
      );
      setFormData((prevState) => ({
        ...prevState,
        id: devoir_sms_setting[0]?._id!,
        status: devoir_sms_setting[0].sms_status,
      }));
    }
  }, [AllSmsSettings, isLoading]);

  const onChangeDevoirSmsSetting = () => {
    let updateData = {
      id: formData.id,
      status: formData.status === "1" ? "0" : "1",
    };
    updateAvisSmsSetting(updateData)
      .then(() =>
        setFormData((prevState) => ({
          ...prevState,
          status: formData.status === "1" ? "0" : "1",
        }))
      )
      .then(() =>
        notifySuccess("Paramètre Devoirs SMS a été modifié avec succès")
      );
  };

  const [createCalendrier] = useAddCalendrierMutation();

  const initialCalendrier = {
    salle: "",
    trimestre: "",
    heure_debut: "",
    heure_fin: "",
    date: "",
    matiere: "",
    classe: "",
    type: "",
    // enseignant: "",
  };

  const [calendrier, setCalendrier] = useState(initialCalendrier);

  const {
    salle,
    trimestre,
    heure_debut,
    heure_fin,
    date,
    matiere,
    classe,
    type,
    // enseignant,
  } = calendrier;

  const [calendrierList, setCalendrierList] = useState([initialCalendrier]);

  const handleAddRow = () => {
    setCalendrierList([...calendrierList, initialCalendrier]);
  };

  const handleDeleteRow = (index: number) => {
    const updatedList = calendrierList.filter((_, i) => i !== index);
    setCalendrierList(updatedList);
  };

  const handleSelectChange = (e: any, index: number) => {
    const { name, value } = e.target;
    const updatedCalendrierList = [...calendrierList];
    updatedCalendrierList[index] = {
      ...updatedCalendrierList[index],
      [name]: value,
    };
    setCalendrierList(updatedCalendrierList);
  };

  const handleManyDateChange = (date: Date[], index: number) => {
    const updatedCalendrierList = [...calendrierList];
    updatedCalendrierList[index] = {
      ...updatedCalendrierList[index],
      date: formatDate(date[0]),
    };
    setCalendrierList(updatedCalendrierList);
  };

  const handleManyStartTimeChange = (time: Date[], index: number) => {
    const updatedCalendrierList = [...calendrierList];
    updatedCalendrierList[index] = {
      ...updatedCalendrierList[index],
      heure_debut: formatTime(time[0]),
    };
    setCalendrierList(updatedCalendrierList);
  };

  const handleEndManyTimeChange = (time: Date[], index: number) => {
    const updatedCalendrierList = [...calendrierList];
    updatedCalendrierList[index] = {
      ...updatedCalendrierList[index],
      heure_fin: formatTime(time[0]),
    };
    setCalendrierList(updatedCalendrierList);
  };

  const handleSelectManySalle = (e: any, index: number) => {
    const { value } = e.target;
    const updatedCalendrierList = [...calendrierList];
    updatedCalendrierList[index] = {
      ...updatedCalendrierList[index],
      salle: value,
    };
    setCalendrierList(updatedCalendrierList);
  };

  const [classetoAdd, setClasseToAdd] = useState("");
  const [trimestretoAdd, setTrimestreToAdd] = useState("");

  const handleSelectTrimestreToAdd = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const value = event.target.value;
    setTrimestreToAdd(value);
  };

  const handleSelectClasseToAdd = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setClasseToAdd(e.target.value);
  };

  const onSubmitManyCalendrier = async (
    e: React.FormEvent<HTMLFormElement>
  ) => {
    e.preventDefault();
    try {
      const updatedCalendrierList = calendrierList.map((calendrier) => ({
        ...calendrier,
        classe: classetoAdd,
        trimestre: trimestretoAdd,
        type: "Synthèse",
      }));
      await Promise.all(
        updatedCalendrierList.map((calendrier) => createCalendrier(calendrier))
      );
      notifySuccess("Le calendrier a été créé avec succès");
      setCalendrierList([initialCalendrier]);
      setClasseToAdd("");
      setTrimestreToAdd("");
      navigate("/calendrier-examen-synthèse");
    } catch (error) {
      notifyError(error);
    }
  };

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Classe</span>,
      selector: (row: any) => <span>{row?.classe?.nom_classe!}</span>,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Matiere</span>,
      selector: (row: any) => row?.matiere!,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Date</span>,
      selector: (row: any) => row.date,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">De</span>,
      selector: (row: any) => row.heure_debut,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Jusqu'à</span>,
      selector: (row: any) => row.heure_fin,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Salle</span>,
      selector: (row: any) => row?.salle?.nom_salle!,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Trimestre</span>,
      selector: (row: any) => row.trimestre,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Actions</span>,
      sortable: true,
      cell: (row: any) => {
        return (
          <ul className="hstack gap-2 list-unstyled mb-0">
            <li>
              <Link
                to="#"
                className="badge badge-soft-info edit-item-btn"
                onClick={() => setShowCalendrier(!showCalendrier)}
                state={row}
              >
                <i
                  className="ri-eye-line"
                  style={{
                    transition: "transform 0.3s ease-in-out",
                    cursor: "pointer",
                    fontSize: "1.2em",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.3)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                ></i>
              </Link>
            </li>
            <li>
              <Link
                to="#"
                className="badge badge-soft-success edit-item-btn"
                onClick={() => tog_UpdateCalendrier()}
                state={row}
              >
                <i
                  className="ri-edit-2-line"
                  style={{
                    transition: "transform 0.3s ease-in-out",
                    cursor: "pointer",
                    fontSize: "1.2em",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.3)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                ></i>
              </Link>
            </li>
            <li>
              <Link to="#" className="badge badge-soft-danger remove-item-btn">
                <i
                  className="ri-delete-bin-2-line"
                  style={{
                    transition: "transform 0.3s ease-in-out",
                    cursor: "pointer",
                    fontSize: "1.2em",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.3)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                  onClick={() => AlertDelete(row._id)}
                ></i>
              </Link>
            </li>
          </ul>
        );
      },
    },
  ];

  const calendrierLocation = useLocation();

  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const getFilteredCalendriers = () => {
    let filteredCalendriers = [...syntheseData];

    if (searchTerm) {
      filteredCalendriers = filteredCalendriers.filter(
        (calendrier: any) =>
          calendrier
            ?.matiere!.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          calendrier
            ?.trimestre!.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          calendrier
            ?.heure_debut!.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          calendrier?.date!.toLowerCase().includes(searchTerm.toLowerCase()) ||
          calendrier
            ?.heure_fin!.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          calendrier?.classe
            ?.nom_classe!.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          calendrier?.salle
            ?.nom_salle!.toLowerCase()
            .includes(searchTerm.toLowerCase())
      );
    }

    return filteredCalendriers.reverse();
  };

  const { data: manyAllMatieresByClasseId = [] } =
    useFetchMatieresByClasseIdQuery(classetoAdd, { skip: !classetoAdd });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title="Calendrier des examens"
            pageTitle="Tableau de bord"
          />
          <Col lg={12}>
            <Card id="shipmentsList">
              <Card.Header className="border-bottom-dashed">
                <Row className="g-3">
                  <Col lg={3}>
                    <div className="search-box">
                      <input
                        type="text"
                        className="form-control search"
                        placeholder="Rechercher ..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <Row>
                      <Col lg={2}>
                        <Form.Label>Status SMS: </Form.Label>
                      </Col>
                      <Col lg={2}>
                        <div className="form-check form-switch">
                          <input
                            key={formData?.id!}
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id={formData.id}
                            checked={formData.status === "1"}
                            onChange={() => onChangeDevoirSmsSetting()}
                          />
                          {formData.status === "0" ? (
                            <span className="badge bg-warning-subtle text-warning badge-border">
                              Désactivé
                            </span>
                          ) : (
                            <span className="badge bg-info-subtle text-info badge-border">
                              Activé
                            </span>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={3} className="d-flex justify-content-end">
                    <div
                      className="btn-group btn-group-sm"
                      role="group"
                      aria-label="Basic example"
                    >
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => tog_AddCalendrier()}
                      >
                        <i
                          className="ri-add-fill align-middle"
                          style={{
                            transition: "transform 0.3s ease-in-out",
                            cursor: "pointer",
                            fontSize: "1.5em",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.transform = "scale(1.3)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                          }
                        ></i>{" "}
                        <span>Ajouter Calendrier</span>
                      </button>
                    </div>
                  </Col>
                </Row>
              </Card.Header>
              <Card.Body>
                <DataTable
                  columns={columns}
                  data={getFilteredCalendriers()}
                  pagination
                />
              </Card.Body>
            </Card>
          </Col>
          <Modal
            className="fade"
            id="createModal"
            show={modal_AddCalendrier}
            onHide={() => {
              tog_AddCalendrier();
            }}
            centered
            size="xl"
          >
            <Modal.Header closeButton>
              <h1 className="modal-title fs-5" id="createModalLabel">
                Ajouter Calendrier
              </h1>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col xxl={12}>
                  <Card>
                    <Card.Body>
                      <Form
                        className="create-form"
                        onSubmit={onSubmitManyCalendrier}
                      >
                        <Row>
                          <Col lg={12}>
                            <Row className="mb-4">
                              <Col lg={2}>
                                <Form.Label htmlFor="classetoAdd">
                                  Classe
                                </Form.Label>
                              </Col>
                              <Col lg={3}>
                                <Select
                                  options={[...AllClasses].sort((a: any, b: any) => (a.nom_classe || "").localeCompare(b.nom_classe || "", "fr")).map((classe) => ({
                                    value: classe?._id!,
                                    label: classe.nom_classe,
                                  }))}
                                  value={classetoAdd ? { value: classetoAdd, label: AllClasses.find((c: any) => c._id === classetoAdd)?.nom_classe || "" } : null}
                                  onChange={(opt: any) => { const e = { target: { value: opt?.value || "" } } as any; handleSelectClasseToAdd(e); }}
                                  placeholder="Rechercher une classe..."
                                  isClearable
                                  isSearchable
                                  noOptionsMessage={() => "Aucune classe trouvée"}
                                />
                              </Col>
                              <Col lg={2}>
                                <Form.Label htmlFor="trimestretoAdd">
                                  Trimestre
                                </Form.Label>
                              </Col>
                              <Col lg={3}>
                                <select
                                  className="form-select text-muted"
                                  name="trimestretoAdd"
                                  id="trimestretoAdd"
                                  value={trimestretoAdd}
                                  onChange={handleSelectTrimestreToAdd}
                                >
                                  <option value="">Choisir</option>
                                  <option value="1er trimestre">
                                    1er trimestre
                                  </option>
                                  <option value="2ème trimestre">
                                    2ème trimestre
                                  </option>
                                  <option value="3ème trimestre">
                                    3ème trimestre
                                  </option>
                                </select>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={12}>
                            <Row>
                              <Col>
                                <Form.Label htmlFor="matiere">
                                  Matière
                                </Form.Label>
                              </Col>
                              {/* <Col>
                                    <Form.Label htmlFor="enseignant">
                                      Enseignant
                                    </Form.Label>
                                  </Col> */}
                              <Col>
                                <Form.Label htmlFor="date">Date</Form.Label>
                              </Col>
                              <Col>
                                <Form.Label htmlFor="heure_debut">
                                  Commence à
                                </Form.Label>
                              </Col>
                              <Col>
                                <Form.Label htmlFor="heure_fin">
                                  Jusqu'à
                                </Form.Label>
                              </Col>
                              <Col>
                                <Col lg={3}>
                                  <Form.Label htmlFor="salle">Salle</Form.Label>
                                </Col>
                              </Col>
                              <Col lg={1}></Col>
                              <Col lg={1}></Col>
                            </Row>
                            {calendrierList.map((calendrier, index) => (
                              <Row>
                                <Col>
                                  <Select
                                    options={manyAllMatieresByClasseId.flatMap((matiere) =>
                                      matiere.matieres.map((m) => ({
                                        value: m.nom_matiere,
                                        label: m.nom_matiere,
                                      }))
                                    ).sort((a, b) => a.label.localeCompare(b.label, "fr"))}
                                    value={calendrier.matiere ? { value: calendrier.matiere, label: calendrier.matiere } : null}
                                    onChange={(opt: any) => { const e = { target: { value: opt?.value || "", name: "matiere" } } as any; handleSelectChange(e, index); }}
                                    placeholder="Matière..."
                                    isClearable
                                    isSearchable
                                    noOptionsMessage={() => "Aucune matière trouvée"}
                                  />
                                </Col>
                                {/* <Col>
                                    <select
                                      className="form-select text-muted"
                                      name="enseignant"
                                      id="enseignant"
                                      onChange={handleSelectEnseignant}
                                    >
                                      <option value="">Select</option>
                                      {AllEnseignants.map((enseignant) => (
                                        <option
                                          value={enseignant?._id!}
                                          key={enseignant?._id!}
                                        >
                                          {enseignant.nom_enseignant}{" "}
                                          {enseignant.prenom_enseignant}
                                        </option>
                                      ))}
                                    </select>
                                  </Col> */}
                                <Col>
                                  <Flatpickr
                                    className="form-control flatpickr-input"
                                    placeholder="Date examen"
                                    onChange={(date) =>
                                      handleManyDateChange(date, index)
                                    }
                                    options={{
                                      dateFormat: "d M, Y",
                                      locale: French,
                                    }}
                                    id="date"
                                    name="date"
                                  />
                                </Col>
                                <Col>
                                  <Flatpickr
                                    className="form-control"
                                    options={{
                                      enableTime: true,
                                      noCalendar: true,
                                      dateFormat: "H:i",
                                      time_24hr: true,
                                    }}
                                    onChange={(time) =>
                                      handleManyStartTimeChange(time, index)
                                    }
                                  />
                                </Col>
                                <Col>
                                  <Flatpickr
                                    className="form-control"
                                    options={{
                                      enableTime: true,
                                      noCalendar: true,
                                      dateFormat: "H:i",
                                      time_24hr: true,
                                    }}
                                    onChange={(time) =>
                                      handleEndManyTimeChange(time, index)
                                    }
                                  />
                                </Col>
                                <Col>
                                  <Select
                                    options={[...AllSalles].sort((a: any, b: any) => (a.nom_salle || "").localeCompare(b.nom_salle || "", "fr")).map((salle) => ({
                                      value: salle?._id!,
                                      label: salle.nom_salle,
                                    }))}
                                    value={calendrier.salle ? { value: calendrier.salle, label: AllSalles.find((s: any) => s._id === calendrier.salle)?.nom_salle || "" } : null}
                                    onChange={(opt: any) => { const e = { target: { value: opt?.value || "", name: "salle" } } as any; handleSelectManySalle(e, index); }}
                                    placeholder="Salle..."
                                    isClearable
                                    isSearchable
                                    noOptionsMessage={() => "Aucune salle trouvée"}
                                  />
                                </Col>
                                <Col lg={1} className="m-1">
                                  {index === calendrierList.length - 1 && (
                                    <button
                                      type="button"
                                      className="btn btn-soft-info btn-icon"
                                      onClick={handleAddRow}
                                    >
                                      <i className="ri-add-line"></i>
                                    </button>
                                  )}
                                </Col>
                                <Col lg={1} className="m-1">
                                  <button
                                    type="button"
                                    className="btn btn-danger btn-icon"
                                    onClick={() => handleDeleteRow(index)}
                                  >
                                    <i className="ri-delete-bin-5-line"></i>
                                  </button>
                                </Col>
                              </Row>
                            ))}
                          </Col>
                        </Row>
                        <Row className="mt-3">
                          <div className="hstack gap-2 justify-content-end">
                            <Button
                              variant="light"
                              onClick={() => {
                                tog_AddCalendrier();
                                setCalendrier(initialCalendrier);
                              }}
                            >
                              Fermer
                            </Button>
                            <Button
                              onClick={() => {
                                tog_AddCalendrier();
                              }}
                              type="submit"
                              variant="success"
                              id="addNew"
                            >
                              Ajouter
                            </Button>
                          </div>
                        </Row>
                      </Form>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Modal.Body>
          </Modal>
          <Modal
            className="fade"
            id="createModal"
            show={modal_UpdateCalendrier}
            onHide={() => {
              tog_UpdateCalendrier();
            }}
            centered
            size="lg"
          >
            <Modal.Header closeButton>
              <h1 className="modal-title fs-5" id="createModalLabel">
                Modifier Calendrier
              </h1>
            </Modal.Header>
            <Modal.Body>
              <UpdateCalendrier
                modal_UpdateCalendrier={modal_UpdateCalendrier}
                setmodal_UpdateCalendrier={setmodal_UpdateCalendrier}
              />
            </Modal.Body>
          </Modal>
        </Container>
        <Offcanvas
          show={showCalendrier}
          onHide={() => setShowCalendrier(!showCalendrier)}
          placement="end"
          style={{ width: "40%" }}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Détails Calendrier</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Row className="mb-3">
              <Col lg={3}>
                <span className="fw-medium">Classe</span>
              </Col>
              <Col lg={9}>
                <i>{calendrierLocation?.state?.classe?.nom_classe!}</i>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col lg={3}>
                <span className="fw-medium">Matiere</span>
              </Col>
              <Col lg={9}>
                <i>{calendrierLocation?.state?.matiere!}</i>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col lg={3}>
                <span className="fw-medium">Date Examen</span>
              </Col>
              <Col lg={9}>
                <i>{calendrierLocation?.state?.date!}</i>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col lg={3}>
                <span className="fw-medium">De</span>
              </Col>
              <Col lg={9}>
                <i>{calendrierLocation?.state?.heure_debut!}</i>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col lg={3}>
                <span className="fw-medium">Jusqu'à</span>
              </Col>
              <Col lg={9}>
                <i>{calendrierLocation?.state?.heure_fin!}</i>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col lg={3}>
                <span className="fw-medium">Trimestre</span>
              </Col>
              <Col lg={9}>
                <i>{calendrierLocation?.state?.trimestre!}</i>
              </Col>
            </Row>
            {/* <Row className="mb-3">
              <Col lg={3}>
                <span className="fw-medium">Enseignant</span>
              </Col>
              <Col lg={9}>
                <i>
                  {calendrierLocation?.state?.enseignant?.nom_enseignant}{" "}
                  {calendrierLocation?.state?.enseignant?.prenom_enseignant}
                </i>
              </Col>
            </Row> */}
            <Row className="mb-3">
              <Col lg={3}>
                <span className="fw-medium">Salle</span>
              </Col>
              <Col lg={9}>
                <i>{calendrierLocation?.state?.salle?.nom_salle!}</i>
              </Col>
            </Row>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </React.Fragment>
  );
};
export default DevoirSynthese;
